// WeightAuditor Getters

export const getWeightAuditorList = state => {
  return state.weightAuditorList
}

export const getWeightAuditorInfo = state => {
  return state.weightAuditorInfo
}

export const getWeightAuditorTypes = state => {
  return state.weightAuditorTypes
}

export const getMorningTimes = state => {
  return state.morningTimes
}

export const getEveningTimes = state => {
  return state.eveningTimes
}
